import { API_BASE } from "helpers/api_config";
import { gorselYuklemeParametreleri } from "helpers/gorselKucult";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import {
  requiredText,
} from "helpers/validators";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import AdSlotGuide from "components/Common/AdSlotGuide";
import { AD_SYSTEM, findSlot, slotNoText } from "helpers/adSlots";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';

import "jspdf-autotable";


import Dropzone from 'react-dropzone-uploader';


import {
  getAdvertesing_Category as onGetAdvertesingCategory,
  addAdvertesing_Category as onAddAdvertesingCategory,
  updateAdvertesing_Category as onUpdateAdvertesingCategory,
  deleteAdvertesing_Category as onDeleteAdvertesingCategory,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

import SayfaRehberi from "../../../components/Common/SayfaRehberi";
const ContactsList = props => {

  //meta title
  document.title = "REKLAM Kategorisi | BERLİN ESNAF ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();

  const [getHtmlDataLong, setHtmlDataLong] = useState();
  const [getFileSubMedia, setFileSubMedia] = useState([]);
  const [getFileSubMediaAdd, setFileSubMediaAdd] = useState([]);

  const [getSubMediaID, setSubMediaID] = useState();
  const [getIsActive, setIsActive] = useState(false);


  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.Advertesing_Category_Title) || "",
     
    },
    validationSchema: Yup.object({
      title: requiredText("Kategori adı"),
    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          Advertesing_Category_Title: values.title,
 
         

        };
        dispatch(onUpdateAdvertesingCategory(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          Advertesing_Category_Title: values["title"],
       
       

        };
        // save new user
        dispatch(onAddAdvertesingCategory(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.advertesingcategory,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);


  const [getCategoryID, setCategoryID] = useState(null);


  const [getCategory, setCategory] = useState([]);


  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
     
      {
        // Kategori adi = uygulamadaki reklam alani. Hangi numaraya ve hangi
        // ekrana denk geldigi burada gosteriliyor (bkz. helpers/adSlots.js).
        Header: "Alan No",
        id: "adSlotNo",
        disableFilters: true,
        accessor: "Advertesing_Category_Title",
        Cell: cellProps => {
          const slot = findSlot(AD_SYSTEM.FORM, cellProps.value);
          if (!slot) {
            return (
              <span className="badge badge-soft-danger font-size-11">?</span>
            );
          }
          return (
            <span
              className={
                "badge font-size-12 " +
                (slot.status === "off"
                  ? "badge-soft-secondary"
                  : "badge-soft-primary")
              }
            >
              {slotNoText(slot.no)}
            </span>
          );
        },
      },

      {
        Header: "Reklam Başlık",
        accessor: "Advertesing_Category_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Uygulamada Nerede Görünüyor",
        id: "adSlotWhere",
        disableFilters: true,
        accessor: "Advertesing_Category_Title",
        Cell: cellProps => {
          const slot = findSlot(AD_SYSTEM.FORM, cellProps.value);
          if (!slot) {
            return (
              <span className="text-danger font-size-12">
                Rehberde tanımlı değil — kategori adı değiştirilmiş olabilir,
                bu kategorideki reklamlar uygulamada görünmez.
              </span>
            );
          }
          if (slot.status === "off") {
            return (
              <span className="text-muted font-size-12">
                Kullanılmıyor — bu alanı okuyan bir ekran yok.
              </span>
            );
          }
          return (
            <div style={{ minWidth: 220 }}>
              <div className="font-size-12">{slot.where}</div>
              {slot.screens && slot.screens.length > 1 ? (
                <div className="text-muted font-size-11">
                  Ayrıca: {slot.screens.slice(1).join(", ")}
                </div>
              ) : null}
            </div>
          );
        },
      },




      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">

             

              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  // NOT: burada başka bir projeden (Luxun/MSE/Kupon) kalma `_getAuthData`
  // vardı; ölü :9093 portuna istek atıyor, sonucu (`getCategory`) hiçbir yerde
  // gösterilmiyordu. Her sayfa açılışında yakalanmamış hata üretiyordu — kaldırıldı.

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetAdvertesingCategory());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };


  // ⚠️ ÖLÜ KOD: aşağıdaki medya galerisi (handleUserClickMedia / _addMedia /
  //    _deleteMedia + modalMedia) Luxun projesinden kalma. `handleUserClickMedia`
  //    hiçbir yerden ÇAĞRILMIYOR, yani modal hiç açılmıyor ve içindeki :9093
  //    çağrıları hiç çalışmıyor. Berlin OData'da `Products` tablosu yok, bu yüzden
  //    OData'ya çevrilemez. Temizlenecekse JSX ile birlikte kaldırılmalı.
  const handleUserClickMedia = (arg) => {
    const user = arg;

    setSubMediaID(user.ID)

    setFileSubMedia(user.Products_Image)

    toggleMedia();
  };


  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);

   
    setIsEdit(true);


    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };
  // NOT: burada `setContact(<liste>)` çağıran iki useEffect vardı.
  // `contact` SEÇİLİ SATIRI tutuyor; liste her değiştiğinde tüm dizi ile
  // eziliyor, dizide `.ID` olmadığı için silme sessizce hiçbir şey yapmıyordu.

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteAdvertesingCategory(contact.ID));
    }
    setContact(undefined);
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  const _deleteMedia = async (itemData) => {

    try {

      axios.delete(`${API_BASE}/deleteProductImageLuxun/${itemData.ID}`).then(async (res) => {

        await axios.get(`${API_BASE}/getProductsMediaLuxun/select/${getSubMediaID}`)
          .then((res) => {
            setFileSubMedia(res.data)
          })


      })
    } catch (error) {
      //yield put(updateUserFail(error))
    }


    /*  const filteredData = getFileSubMediaAdd.filter(item => item.ID !== itemData.ID )
      setFileSubMediaAdd(filteredData);*/

  }

  const _addMedia = async () => {


    getFileSubMediaAdd.map(async (item, index) => {
      const newUser = {
        Products_ID: getSubMediaID,
        //EducationSubItem_Media_Type: item.fileType,
        Url: item.fileName
      }

      axios.post(API_BASE + '/addProductsMediaLuxun/send', newUser)

      await axios.get(`${API_BASE}/getProductsMediaLuxun/select/${getSubMediaID}`)
        .then((res) => {
          setFileSubMedia(res.data)
        })

      toggleMedia();
    })
  }

  // Gorseller yuklenmeden once kucultulur (bkz. helpers/gorselKucult.js)
  const getUploadParams = gorselYuklemeParametreleri

  const handleChangeStatusBanner = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response)
          setFileSubMediaAdd(oldArray => [{ fileName: result.file.filename, fileType: result.file.mimetype }, ...oldArray]);
        }
      }
    }
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Reklam Kategori Listesi" />
          <SayfaRehberi sayfa="advertesingcategory" />

          {/* Kategori adlari uygulamadaki alanlarla ADIYLA eslesiyor;
              hangi adin hangi numaraya denk geldigi bu rehberde. */}
          <div className="alert alert-warning font-size-13">
            <i className="bx bx-error-circle align-middle me-1" />
            Buradaki kategori adları uygulamadaki reklam alanlarıyla
            <strong> birebir</strong> eşleşir. Bir adı değiştirirseniz o alan
            uygulamada boşalır ve o kategorideki reklamlar görünmez.
          </div>

          <div className="mb-3">
            <AdSlotGuide highlightSystem={AD_SYSTEM.FORM} />
          </div>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddCategory={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modalMedia} toggle={toggleMedia}>
                    <ModalHeader toggle={toggleMedia} tag="h4">
                      {!!isEdit ? "Düzenle" : "Medya Ekle"}
                    </ModalHeader>
                    <ModalBody>

                      <Row>
                        <Col xs={12}>


                          <div className="mb-3">
                            <label htmlFor="resume">Görsel</label>
                            <Dropzone
                              maxFiles={5}
                              getUploadParams={getUploadParams}
                              multiple={true}
                              onChangeStatus={handleChangeStatusBanner}
                              styles={{
                                dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                inputLabelWithFiles: { margin: '20px 3%' }
                              }}
                              canRemove={true}
                              PreviewComponent={Preview}
                              accept="image/*"
                            />
                          </div>

                        </Col>
                      </Row>
                      <Row>

                        {getFileSubMedia.map((item, index) => (
                          <div key={index}>
                            <img src={'https://megasubdomain.stechomeyazilim.info/' + item.Url} alt="" className="avatar-sm" />

                            <button
                              onClick={() => _deleteMedia(item)}
                              type="submit"
                              className="btn btn-danger save-user"
                            >
                              Sil
                            </button>

                          </div>
                        ))}



                        <Col>
                          <div className="text-end">
                            <button
                              onClick={() => _addMedia()}
                              type="submit"
                              className="btn btn-success save-user"
                            >
                              Medyaları Kaydet
                            </button>
                          </div>
                        </Col>
                      </Row>

                    </ModalBody>
                  </Modal>

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Reklam Kategorisi Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>



                            <div className="mb-3">
                              <Label className="form-label">Reklam Kategorisi</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Reklam Kategorisi Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>


                        
                          </Col>
                        </Row>
                         <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                   
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
